import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { Xdp, XdpServerResponse } from 'data/xdp/xdp.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: XdpServerResponse,
  originalDigitExtractionServerFormData: Xdp | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.XDP_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.XDP_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.IPDUID,
    AuditService.XDP,
    actionType,
  );
  return auditDetails as AuditDetails;
}
